import { Suspense, useContext, useEffect, useState, useRef } from "react";
import { fetchData } from "./data";
import { Button, IconBut } from "../ui/buttons";
import { Host, Loading } from "../App";
import { SearchBar } from "./library";


export default function Folders({ active, name }) {
    const mainRef = useRef(null);

    useEffect(() => {
        active === name && mainRef.current.scrollIntoView({
            behaviour: "smooth",
            inline: "start"
        })
    }, [name, active]);


    return (
        <div className="max" ref={mainRef} style={{ backgroundColor: "blue" }}>
            <div className="max pad" style={{ overflow: "hidden auto" }}>
                <Suspense fallback={<Loading />}>
                    <FolderList />
                </Suspense>
            </div>
        </div>
    )
}


function FolderList() {
    const [filter, setFilter] = useState('');

    const list = fetchData(`${Host}/api/folders`, devData);


    return (
        <>
            <SearchBar value={filter} changeSearch={setFilter} />
            {
                list.length ?
                    <div className="flex f-list">
                        {
                            list.map(item =>
                                <Folder key={item.id} data={item} filter={filter} />
                            )
                        }
                    </div>
                    :
                    <div className="abs-mid">
                        {/* image */}
                        <p>
                            Group study texts and materials to keep <br />
                            things organized and share with squad members
                        </p>
                        <div className="margin">
                            <Button> Create a Folder </Button>
                        </div>
                    </div>
            }
        </>
    )
}

function Folder({ data, filter }) {
    const { title, descr } = data;

    return (
        filter && !(title.includes(filter) || descr.includes(filter)) ?
            <></>
            :
            <div className="f-item br-1" style={{ margin: "10px" }}>
                <div className="flex">
                    {/* folder image */}
                    <div className="flex-col" style={{ padding: "5px" }}>
                        <span style={{ fontWeight: "500" }}> {title} </span>
                        <small> {descr} </small>
                    </div>
                </div>
            </div>

    )
}




const devData = [
    { title: "CHE 102", descr: "Folder containing CHE 102 materials" },
    { title: "GNS 102", descr: "Folder containing GNS 102 materials" },
    { title: "PHY 102", descr: "Folder containing PHY 102 materials" },
    { title: "MTS 102", descr: "Folder containing MTS 102 materials" },
    { title: "GNS 106", descr: "Folder containing GNS 106 materials" },
    { title: "CSC 102", descr: "Folder containing CSC 102 materials" },
]